import { render, staticRenderFns } from "./Day.vue?vue&type=template&id=24a32718&scoped=true"
import script from "./Day.vue?vue&type=script&lang=js"
export * from "./Day.vue?vue&type=script&lang=js"
import style0 from "./Day.vue?vue&type=style&index=0&id=24a32718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a32718",
  null
  
)

export default component.exports